<template>
  <div class="Contactus">
    <div class="cont wow bounceInUp">
      <ComTitlte
        titleEn="CONTACT US"
        titleZh="联系我们"
        zhColor="#333333"
      ></ComTitlte>
      <div class="main">
        <div class="m_left">
          <div class="m_title">请填写您的需求</div>
          <el-form
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules"
            class="fromBox"
            hide-required-asterisk
            label-position="left"
            label-width="100px"
            size="mini"
          >
            <div class="box_left">
              <el-form-item label="需求类型：" prop="type">
                <el-select v-model="ruleForm.type" placeholder="请选择需求类型">
                  <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联系人：" prop="createUser">
                <el-input
                  v-model="ruleForm.createUser"
                  placeholder="请输入联系人姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系电话：" prop="onlinePhone">
                <el-input
                  v-model="ruleForm.onlinePhone"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="提交附件：" prop="fileUrl">
                <el-upload
                  :before-upload="beforeUploadFile"
                  :file-list="fileList"
                  :limit="1"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  action="/api/fApi/common/upload"
                  class="upload-demo"
                >
                  <el-button class="btn_upload_file" type="primary">
                    选择文件
                  </el-button>
                  <!-- <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件，且不超过500kb
                  </div> -->
                </el-upload>
              </el-form-item>
            </div>
            <div class="box_right">
              <el-form-item label="需求描述：" prop="onlineContent">
                <el-input
                  v-model="ruleForm.onlineContent"
                  :rows="9"
                  class="box_input_textarea"
                  maxlength="300"
                  placeholder="请填写您的需求"
                  type="textarea"
                >
                </el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="box_btn">
            <el-button
              class="btn_submit"
              type="primary"
              @click="onSubmit('ruleForm')"
            >
              提交需求
            </el-button>
          </div>
        </div>
        <div class="m_right">
          <ul>
            <li>
              <i class="cicon cicon_phone"></i>
              <span>统一服务热线 ：020-83523942</span>
            </li>
            <li>
              <i class="cicon cicon_adress"></i>
              <span>地址：广州市越秀区文德路67号金德大厦9楼</span>
            </li>
            <li>
              <i class="cicon cicon_email"></i>
              <span>邮箱：office@gztjssws.com</span>
            </li>
            <li>
              <i class="cicon cicon_time"></i>
              <span>工作时间：周一至周五09:00-18:00</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="请输入验证码" width="400px">
      <div class="line">
        <el-input
          v-model="ruleForm.code"
          class="input_code"
          placeholder="请输入验证码"
        >
        </el-input>
        <img
          :src="chaObj.img ? url + chaObj.img : ''"
          alt="..."
          class="chaImg"
          @click="chaImg"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseCode">取 消</el-button>
        <el-button type="primary" @click="addLine"> 确 定 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";

export default {
  name: "Contactus",
  data() {
    var checkMobile = (rule, value, callback) => {
      var regu = /^1[3456789]\d{9}$/;
      var re = new RegExp(regu);
      if (re.test(value)) {
        callback();
      } else {
        callback("请输入正确的手机号码");
      }
    };
    return {
      url: "data:image/gif;base64,",
      chaObj: "", // 图片信息
      dialogVisible: false, // 是否显示验证码弹窗
      ruleForm: {
        type: [],
        createUser: "",
        onlinePhone: "",
        onlineContent: "",
        fileUrl: "",
        retainfield1: "",
        retainfield2: "",
        code: "",
        uuid: "",
      },
      rules: {
        type: [
          {
            required: true,
            message: "请至少选择一个需求类型",
            trigger: "blur",
          },
        ],
        createUser: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
        ],
        onlinePhone: [
          { required: true, message: "请输入您的手机号码", trigger: "blur" },
          { validator: checkMobile, trigger: "blur" },
        ],
        onlineContent: [
          { required: true, message: "请填写您的需求描述", trigger: "blur" },
        ],
      },
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
        // {
        //   name: "food2.jpeg",
        //   url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        // },
      ],
      typeOptions: [
        {
          value: "1",
          label: "专项统计与统计数据咨询",
        },
        {
          value: "2",
          label: "社情民意调查研究",
        },
        {
          value: "3",
          label: "统计报表代填代报",
        },
        {
          value: "4",
          label: "技术咨询",
        },
      ],
    };
  },
  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  methods: {
    //上传附件之前
    beforeUploadFile(data) {
      console.log(data);
    },
    // 图片删除
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList.filter(function (item) {
        return item != file;
      });
      this.ruleForm.fileUrl = "";
    },
    // 上传成功
    handleSuccess(response, file) {
      // console.log(response);
      this.fileList.push({
        name: file.name,
        url: response.fileName,
      });
      this.ruleForm.fileUrl = JSON.stringify({
        name: file.name,
        url: response.fileName,
      });
    },
    async chaImg() {
      let imgobj = await this.$request.getChaimg();
      this.chaObj = imgobj;
      this.ruleForm.uuid = imgobj.uuid;
    },
    addLine() {
      if (!this.ruleForm.code) {
        this.$alert("请输入验证码", "温馨提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.ruleForm.retainfield1 = this.ruleForm.fileUrl;
      this.ruleForm.retainfield2 = this.ruleForm.type[0];
      //联系方式
      this.$request.postaddInfo(this.ruleForm).then((res) => {
        if (res.code == "200") {
          this.$message.success("您的需求，已提交成功");
          this.dialogVisible = false;
          this.ruleForm = {
            type: [],
            createUser: "",
            onlinePhone: "",
            onlineContent: "",
            fileUrl: "",
            retainfield1: "",
            retainfield2: "",
            code: "",
            uuid: "",
          };
          this.fileList = [];
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    onCloseCode() {
      this.dialogVisible = false;
      this.ruleForm = {
        type: [],
        createUser: "",
        onlinePhone: "",
        onlineContent: "",
        fileUrl: "",
        retainfield1: "",
        retainfield2: "",
        code: "",
        uuid: "",
      };
      this.fileList = [];
    },
    // 提交表单
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //获取验证码
          this.chaImg();
          this.dialogVisible = true;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
.Contactus {
  width: 100%;
  min-width: 1180px;
  min-height: 376px;
  padding: 0 0 40px 0;
  overflow: hidden;
  background-color: #f5f6f9;

  /deep/ .el-upload-list__item-name {
    width: 200px;
    /*强制文字在一行文本框内*/
    white-space: nowrap;
    /*溢出部分文字隐藏*/
    overflow: hidden;
    /*溢出部分省略号处理*/
    text-overflow: ellipsis;
  }

  .cont {
    width: 1180px;
    margin: 0 auto;

    .c_title {
      height: 44px;
      padding: 40px 0 0 0;
      position: relative;

      .t_es {
        font-size: 36px;
        font-weight: bold;
        color: #444444;
        opacity: 0.1;
      }

      .t_zh {
        font-size: 24px;
        line-height: 24px;
        font-weight: bold;
        color: #4466bb;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    }

    .main {
      display: flex;
      padding: 30px 0 0 0;

      .m_left {
        flex: 1;
        flex-shrink: 0;
        padding: 0 30px 0 0;

        .m_title {
          height: 20px;
          line-height: 20px;
          border-left: 6px solid $themeColor;
          font-size: 16px;
          padding-left: 10px;
          color: #333333;
        }

        .fromBox {
          display: flex;
          padding: 24px 0 0 0;

          .box_left {
            padding: 0 40px 0 0;

            /deep/ .el-form-item__label {
              font-size: 16px;
            }
          }

          .box_right {
            flex-shrink: 0;
            width: 416px;

            /deep/ .el-form-item__label {
              font-size: 16px;
            }

            .box_input_textarea /deep/ .el-textarea__inner {
              width: 100%;
              // height: 170px;
              padding: 4px 6px;
              box-sizing: border-box;
            }
          }

          .btn_upload_file {
            width: 100px;
            height: 26px;
            line-height: 26px;
            padding: 0;
            background-color: $themeColor;
            border: none;
          }
        }

        .btn_submit {
          width: 754px;
          height: 34px;
          line-height: 34px;
          padding: 0;
          background-color: $themeColor;
          border: none;
          border-radius: 5px;
        }
      }

      .m_right {
        width: 382px;
        padding: 46px 0 0 0;

        ul {
          li {
            display: flex;
            align-items: center;
            padding: 0 0 32px;

            .cicon {
              display: block;
              width: 20px;
              height: 20px;

              &.cicon_phone {
                background: url(../../assets/img/index/cicon_phone.png)
                  no-repeat;
                background-size: cover;
              }

              &.cicon_adress {
                background: url(../../assets/img/index/cicon_adress.png)
                  no-repeat;
                background-size: cover;
              }

              &.cicon_email {
                background: url(../../assets/img/index/cicon_email.png)
                  no-repeat;
                background-size: cover;
              }

              &.cicon_time {
                background: url(../../assets/img/index/cicon_time.png) no-repeat;
                background-size: cover;
              }
            }

            span {
              flex: 1;
              padding: 0 0 0 10px;
              line-height: 20px;
              display: block;
              font-size: 16px;
              color: #666;
            }
          }
        }
      }
    }
  }

  .line {
    display: flex;

    .input_code {
      position: relative;
    }

    .chaImg {
      position: relative;
    }
  }
}
</style>
